import React from 'react'
import styled from 'styled-components'

const Size = styled.div`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  & > svg {
    width: 100%;
  }
  display: flex;
  align-items: center;
`

const Github = ({ size }) => {
  return (
    <Size size={size}>
      <svg viewBox="0 0 33 32" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16.289 0C7.294 0-.001 7.293-.001 16.29c0 7.197 4.668 13.303 11.142 15.456.815.15 1.112-.352 1.112-.784 0-.387-.014-1.412-.022-2.771-4.531.985-5.487-2.183-5.487-2.183-.741-1.883-1.81-2.383-1.81-2.383-1.478-1.012.113-.99.113-.99 1.635.114 2.495 1.677 2.495 1.677 1.453 2.49 3.812 1.771 4.74 1.354.149-1.053.569-1.77 1.035-2.178-3.617-.41-7.42-1.808-7.42-8.05 0-1.779.635-3.232 1.677-4.372-.168-.412-.727-2.068.159-4.31 0 0 1.368-.439 4.48 1.67a15.602 15.602 0 0 1 4.078-.549c1.383.006 2.777.188 4.078.548 3.11-2.108 4.475-1.669 4.475-1.669.889 2.242.33 3.899.162 4.31 1.044 1.14 1.675 2.593 1.675 4.371 0 6.258-3.81 7.636-7.438 8.04.585.502 1.106 1.497 1.106 3.015 0 2.178-.02 3.935-.02 4.47 0 .435.293.942 1.12.783 6.467-2.159 11.13-8.26 11.13-15.454C32.58 7.293 25.287 0 16.29 0"
          fill="#FEFEFE"
          fillRule="evenodd"
          opacity=".8"
        />
      </svg>
    </Size>
  )
}

export default Github
